// Activity Log Filter Constants based on backend enums

export const ACTIVITY_LOG_CATEGORIES = [
  'Account',
  'Subscription',
  'Subscription Plan',
  'Order',
  'Payment',
] as const;

export const ACTIVITY_LOG_LEVELS = ['Info', 'Problem'] as const;

export type ActivityLogCategory = (typeof ACTIVITY_LOG_CATEGORIES)[number];
export type ActivityLogLevel = (typeof ACTIVITY_LOG_LEVELS)[number];
